/**
 * Type for notification in the app.
 */
export type Notification = {
    duration: number
    message: string,
    title: string,
    type: NotificationType,
};

/**
 * Notification type enum
 */
export enum NotificationType {
    'danger',
    'info',
    'success',
    'warning',
};